import { ReactNode } from 'react'

interface SidebarColumnProps {
  header?: ReactNode
  footer?: ReactNode
  children: ReactNode
}

export const SidebarColumn = ({ header, footer, children }: SidebarColumnProps) => (
  <div className="flex h-full w-[200px] flex-col overflow-y-auto border-r border-border-primary bg-fg-secondary py-3 sm:w-[240px]">
    {header && <div className="mx-3 mb-3 ">{header}</div>}
    <div>{children}</div>
    {footer && <div className="mt-auto">{footer}</div>}
  </div>
)
